import {
  IndicatorSeparatorProps,
  components as RsComponents,
  defaultTheme,
} from 'react-select';
import styled, { css } from 'styled-components';
import { UserTag } from './select';

export const StyledDropdownIndicator = styled(
  RsComponents.DropdownIndicator,
).attrs({
  theme: {
    ...defaultTheme,
  },
})`
  padding: 0 var(--spacing-03);
`;

export const DropdownIndicator = (props: any) => (
  <StyledDropdownIndicator {...props} />
);

export const StyledControl = styled(RsComponents.Control).attrs({
  theme: {
    ...defaultTheme,
    borderRadius: 0,
  },
})``;

export const Control = (props: any) => <StyledControl {...props} />;

export const ClearIndicator = (props: any) => (
  <RsComponents.ClearIndicator {...props} />
);

export const StyledMultiValue = styled(RsComponents.MultiValue).attrs({
  theme: {
    ...defaultTheme,
    borderRadius: 0,
  },
})``;

export const SingleUserValue = ({ data, ...props }: any) => (
  <RsComponents.SingleValue {...props}>
    <UserTag {...data} />
  </RsComponents.SingleValue>
);

export const MultiValue = (props: any) => <StyledMultiValue {...props} />;

export const StyledMultiValueLabel = styled(RsComponents.MultiValueLabel).attrs(
  {
    theme: {
      ...defaultTheme,
      borderRadius: 0,
    },
  },
)``;

export const MultiValueLabel = (props: any) => (
  <StyledMultiValueLabel {...props}>
    <UserTag {...props.data} />
  </StyledMultiValueLabel>
);

export const StyledMultiValueRemove = styled(
  RsComponents.MultiValueRemove,
).attrs({
  theme: {
    ...defaultTheme,
    borderRadius: 0,
  },
})``;

export const MultiValueRemove = ({ data, ...props }: any) => (
  <StyledMultiValueRemove {...props} />
);

export const AvatarOption = (props: any) => (
  <RsComponents.Option {...props}>
    <UserTag {...props.data} />
  </RsComponents.Option>
);

export const TagOption = (props: any) => (
  <RsComponents.Option {...props}>
    <UserTag {...props.data} />
  </RsComponents.Option>
);

export const TagSingleValue = (props: any) => (
  <RsComponents.SingleValue {...props}>
    <UserTag {...props.data} />
  </RsComponents.SingleValue>
);
const StyledInput = styled(RsComponents.Input).attrs({
  theme: {
    ...defaultTheme,
  },
})`
  margin: 0 var(--spacing-02);
  padding: 0;
`;

export const Input = (props: any) => <StyledInput {...props} />;
const StyledIndicatorSeparator = styled(RsComponents.IndicatorSeparator).attrs({
  theme: {
    ...defaultTheme,
  },
})<IndicatorSeparatorProps & { size: string }>`
  ${({ size }) =>
    size === 'small'
      ? css`
          margin: 6px 0;
        `
      : ''};
`;

export const IndicatorSeparator = (props: any) => (
  <StyledIndicatorSeparator {...props} size={props.selectProps.size} />
);

export const Menu = styled(RsComponents.Menu).attrs({
  theme: {
    ...defaultTheme,
  },
})`
  box-shadow: none;
`;
